module.exports = __webpack_public_path__ + "static/nodeLink-dcf8d226fc999d7a860f11a11e22938f.svg";